import './edit-tier-level.scss';

import ErrorSection from "@shared/ui/error-section/error-section";
import HeaderButton from "@shared/ui/header-button/header-button";
import HeaderContent from "@shared/ui/header-content/header-content";
import SkeletonList from "@shared/ui/skeleton-list/skeleton-list";
import { ConfirmDialog } from "primereact/confirmdialog";
import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";

import FormTierLevel from "../form-tier-level/form-tier-level";
import { useEditTierLevel } from "./edit-tier-level.hook";

export function EditTierLevel() {
  const {
    tierLevelData,
    isLoading,
    tierLevelError,
    formMethod,
    actions,
    handleBack,
    handleAction,
  } = useEditTierLevel();

  const title =
    tierLevelData?.name ? <h1>{ tierLevelData?.name }</h1> : <h1>Edit Tier Level</h1>;
  const displayLoading = (
    <div className="card">
      <SkeletonList count={4} />
    </div>
  );
  const displayError = (
    <div className="card">
      <ErrorSection
        title="No Data"
        message="No data found in selected record. Please try again."
      />
    </div>
  );
  const mainContent = (
    <div>
      <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
        <FormTierLevel />
      </section>
    </div>
  );

  return (
    <div id="EditTierLevel" className="tier-level">
      <HeaderContent
        title={title}
        backIcon={<FaChevronLeft />}
        onBack={() => handleBack()}
      >
        <HeaderButton actions={actions} onAction={handleAction} />
      </HeaderContent>
      
      <section className="p-7">
        <ConfirmDialog />
        <FormProvider {...formMethod}>
          {isLoading && displayLoading}
          { tierLevelError && !isLoading && displayError }
          {!isLoading ? mainContent : null}
         </FormProvider>
      </section>
    </div>
  );
}

export default EditTierLevel;